import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { getInsPrice, getTNDSInsurancePrice } from "../../actions/insAct";

import { getInitInsurance, getVehicleModel, getInsurancePrice } from "../../model/insurance";
import { Transmission, RegistryType, TypeRegBox } from "../../components/common/common";
import { commonErr } from "../common/errors";

import Header from "../components/header";
import Footer from "../components/footer";
import RegisterBox from "./registerbox";
import TNDSBox from "./tndsbox";
import { InsuranceProcess } from "./home";

import { TooltipBox } from "./tooltipbox";
import { LoadingInline } from "../common/loading";
import { MessageBox } from "../common/messagebox";
import {
	IcCirclePlus,
	IcCircleMinius,
	IcInsuranceCar,
	Tooltip,
	IcBack,
	IcMinusGreenCircle,
	IcPlusCircle,
} from "../common/svg";

import mic from "../../static/images/landingpage/ins-partner/mic.png";
import pjico from "../../static/images/landingpage/ins-partner/pjico.png";
import pti from "../../static/images/insurance/anonymous/pti.png";

const Insurance = {
	MIC: 0,
	PJICO: 1,
};

const CarOrigins = {
	DOSMETIC: 1,
	FOREIGN: 2,
};

class InsuranceRegister extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			step: 1,
			showModel: false,
			showYear: false,
			regDay: "",
			terms: ["ĐK004", "ĐK005", "ĐK006"],
			showInsPrice: false,
			pkgPrice: {},
			isOpenRegisterBox: false,
			infoCar: {},
			carOrigin: CarOrigins.DOSMETIC,
			isOpenTTBox: false,
			showTNDS: false,
			isOpenTNDSBox: false,
			shown: {},
			shownTNDS: {},
			pkgTNDS: {},
			transmission: Transmission.AUTO,
			makeId: 0,
			modelId: null,
			regType: 0,
			year: 0,
			openChild: {},
			activeModel: {},
		};

		this.myRef = React.createRef();
	}

	componentDidMount() {
		this.getInit();
		this.refreshCheckFilled();
	}

	getInit = () => {
		getInitInsurance().then((response) => {
			if (response.data.error >= commonErr.SUCCESS) {
				this.setState({
					addtionalTerms: response.data.data.addtionalTerms,
					makes: response.data.data.makes,
					registry: response.data.data.registry,
					carOrigins: response.data.data.carOrigins,
				});
			}
		});
	};

	getVModel = (makeId, transmission) => {
		const data = {
			makeId: makeId,
			transmission: transmission,
		};

		getVehicleModel(data).then((response) => {
			if (response.data.error >= commonErr.SUCCESS) {
				this.setState({
					models: response.data.data.models,
					parentModels: response.data.data.parentModels,
				});
			}
		});
	};

	onMakeChange = (id) => {
		const { transmission } = this.state;
		this.setState({
			makeId: id,
			showYear: false,
			years: [],
		});

		if (transmission !== null && transmission > 0) {
			this.getVModel(id, transmission);
			this.setState({
				showModel: true,
				modelId: null,
				showInsPrice: false,
				activeModel: {},
			});
		}

		this.getCarName(id, 0, 0);
	};

	onTransmissionChange = (value) => {
		const { makeId } = this.state;
		this.setState({
			transmission: value,
			showYear: false,
			years: [],
		});

		if (makeId !== null && makeId > 0) {
			this.getVModel(makeId, value);
			this.setState({
				showModel: true,
				modelId: null,
				activeModel: {},
			});
		}
	};

	onModelChange = (model, i) => {
		const { models, makeId, year, activeModel } = this.state;

		for (let i = 0; i < models.length; i++) {
			if (models[i].id === model.id) {
				if (models[i].years) {
					this.setState({
						years: models[i].years,
						showYear: true,
						year: 0,
					});
				} else {
					this.getCarName(makeId, model.id, "");
					this.setState({
						years: [],
						showYear: false,
						year: 0,
					});
				}
			}
		}

		if (model.vehicleType === 7) {
			this.setState({
				regType: 4,
			});
		}

		this.getCarName(makeId, model.id, 0);

		this.setState({
			modelId: model.id,
			showInsPrice: false,
			vehicleType: model.vehicleType,
			activeModel: {
				[i]: !activeModel[i],
			},
		});
	};

	onYearChange = (year) => {
		const { makeId, modelId } = this.state;
		this.setState({
			year: year,
			showInsPrice: false,
		});

		this.getCarName(makeId, modelId, year);
	};

	onYearChangeMobile = (e) => {
		const { makeId, modelId } = this.state;
		this.setState({
			year: e.target.value,
			showInsPrice: false,
		});

		this.getCarName(makeId, modelId, e.target.value);
	};

	onRegDayChange = (date) => {
		this.setState({
			regDay: date,
			showInsPrice: false,
		});
	};

	onRegistryChange = (e) => {
		const { vehicleType } = this.state;
		if (vehicleType === 7) {
			this.setState({
				regType: 4,
			});
		} else {
			this.setState({
				regType: Number(e.target.value),
			});
		}
		this.setState({
			showInsPrice: false,
		});
	};

	onCarOriginChange = (e) => {
		this.setState({
			carOrigin: Number(e.target.value),
		});
	};

	onTermsCheckBoxChange = (e, changePrice) => {
		let lsTerms = [];
		const { terms, addtionalTerms } = this.state;

		if (terms && terms.length > 0) {
			lsTerms = terms.slice();
		}

		const termId = e.target.value;
		if (e.target.checked) {
			lsTerms.push(termId);
		} else {
			lsTerms = lsTerms.filter(function (term) {
				return term !== termId;
			});
		}

		if (addtionalTerms) {
			for (var i = 0; i < addtionalTerms.length; ++i) {
				var checked = false;
				if (lsTerms) {
					for (var j = 0; j < lsTerms.length; ++j) {
						if (addtionalTerms[i].id === lsTerms[j]) {
							checked = true;
							break;
						}
					}
				}

				addtionalTerms[i].checked = checked;
			}
		}

		if (changePrice) {
			const { regDay, regType, transmission, modelId, year, carOrigin } = this.state;

			const data = {
				modelId: modelId,
				transmission: transmission,
				regType: regType,
				regDay: moment(regDay).valueOf(),
				year: year,
				terms: lsTerms,
				carOrigin: carOrigin,
			};

			this.getInsurancePrice(data);
			this.setState({
				terms: lsTerms,
			});
		} else {
			this.setState({
				terms: lsTerms,
				showInsPrice: false,
			});
		}
	};

	getInsurancePrice = (data) => {
		this.props.dispatch(getInsPrice(data));
	};

	getPrice = () => {
		const message = this.isValidInfo();

		if (message !== "") {
			this.setState({
				err: commonErr.FAIL,
				errMsg: message,
			});
			return;
		}

		const { regDay, regType, transmission, modelId, year, terms, carOrigin } = this.state;

		const data = {
			modelId: modelId,
			transmission: transmission,
			regType: regType,
			regDay: moment(regDay).valueOf(),
			year: year,
			terms: terms,
			carOrigin: carOrigin,
		};

		this.setState({
			infoCar: data,
		});

		this.getInsurancePrice(data);

		// getInsurancePrice(data).then(response => {
		// 	if (response.data.error >= commonErr.SUCCESS) {

		// 		this.setState({
		// 			showInsPrice: true,
		// 			discounts: response.data.data.discounts,
		// 			priceMIC: response.data.data.priceMIC,
		// 			pricePJICO: response.data.data.pricePJICO
		// 		})
		// 	}
		// })

		this.setState({
			showInsPrice: true,
		});
	};

	onStep = (step) => {
		if (step === 1) {
			this.setState({
				showTNDS: false,
			});
		}
		this.setState({
			step: step,
			showInsPrice: true,
		});
	};

	getCarName = (makeId, modelId, year) => {
		const { makes, models } = this.state;
		const makeName = makes
			.map((make) => {
				if (make.vehicleMakeId === makeId) return make.name;
			})
			.join("");
		const modelName =
			models &&
			models
				.map((model) => {
					if (model.id === modelId) return model.name;
				})
				.join("");

		if ((year > 0 || year != "") && modelId > 0) {
			this.setState({
				carName: `${makeName} ${modelName} ${year}`,
			});
		} else {
			this.setState({
				carName: "",
			});
		}
	};

	onSubmitPackagePrice = (priceId) => {
		const { priceMIC, pricePJICO } = this.props.ins;
		for (let i = 0; i < priceMIC.length; i++) {
			if (priceMIC[i].id === priceId) {
				this.setState({
					pkgPrice: priceMIC[i],
					ins: Insurance.MIC,
				});
				break;
			} else if (pricePJICO[i].id === priceId) {
				this.setState({
					pkgPrice: pricePJICO[i],
					ins: Insurance.PJICO,
				});
				break;
			} else {
				this.setState({
					pkgPrice: null,
					ins: null,
				});
			}
		}

		this.setState({
			step: 2,
		});
		window.scrollTo(0, 0);
	};

	showRegisterBox = (type) => {
		this.setState({
			isOpenRegisterBox: true,
			type: type,
		});
	};

	hideRegisterBox = (type) => {
		this.setState({
			isOpenRegisterBox: false,
		});
	};

	showTTBox = (nameBox, title) => {
		this.setState({
			isOpenTTBox: true,
			title: title,
			nameBox: nameBox,
		});
	};

	hideTTBox = () => {
		this.setState({
			isOpenTTBox: false,
		});
	};

	showTNDSBox = () => {
		this.setState({
			isOpenTNDSBox: true,
		});
	};

	hideTNDSBox = () => {
		this.setState({
			isOpenTNDSBox: false,
		});
	};

	toggleTNDSBox = () => {
		const { regType, vehicleType } = this.state;

		this.getTNDS(regType, vehicleType, true);

		this.setState({
			showTNDS: !this.state.showTNDS,
		});
	};

	getTNDS = (regType, vehicleType, buySeat) => {
		const data = {
			regType: regType,
			vehicleType: vehicleType,
			buySeat: buySeat,
		};

		this.props.dispatch(getTNDSInsurancePrice(data));
	};

	toggleExplain = (i) => {
		let { shown } = this.state;
		this.setState({
			shown: {
				...shown,
				[i]: !shown[i],
			},
		});
	};

	toggleExplainTNDS = (i) => {
		let { shownTNDS } = this.state;
		this.setState({
			shownTNDS: {
				...shownTNDS,
				[i]: !shownTNDS[i],
			},
		});
	};

	getTNDSParams = (buySeat, vehicleType, regType, priceTNDS) => {
		this.setState({
			pkgTNDS: {
				buySeat: buySeat,
				vehicleType: vehicleType,
				regType: regType,
				priceTNDS: priceTNDS,
			},
		});
	};

	handleScrollToElement = (event) => {
		// window.scrollTo(0, this.myRef.current.offsetTop);
		window.scrollTo({
			top: this.myRef.current.offsetTop,
			behavior: "smooth",
		});
	};

	scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	showChildModel = (i) => {
		let { openChild, activeModel } = this.state;
		this.setState({
			openChild: {
				...openChild,
				[i]: !openChild[i],
			},
			activeModel: {
				...activeModel,
				[i]: false,
			},
		});
	};

	refreshCheckFilled = () => {
		this.setState({
			isMakeFilled: true,
			isRegDayFilled: true,
			isRegTypeFilled: true,
			isTransmissionFilled: true,
			isModelFilled: true,
			isYearFilled: true,
			isTermsFilled: true,
		});
	};

	isValidInfo = () => {
		const { regDay, regType, transmission, modelId, year, terms, makeId } = this.state;

		this.refreshCheckFilled();
		if (makeId === 0 || makeId === null) {
			this.setState({
				isMakeFilled: false,
			});
			return "Bạn chưa chọn hãng xe";
		}
		if (modelId === 0 || modelId === null) {
			this.setState({
				isModelFilled: false,
			});
			return "Bạn chưa chọn mẫu xe";
		}
		if (year === 0 || !year) {
			this.setState({
				isYearFilled: false,
			});
			return "Bạn chưa chọn năm sản xuất";
		}
		if (regDay === "" || !regDay) {
			this.setState({
				isRegDayFilled: false,
			});
			return "Bạn chưa chọn ngày đăng ký hoặc năm sản xuất.";
		}
		if (regType === "" || !regType) {
			this.setState({
				isRegTypeFilled: false,
			});
			return "Bạn chưa chọn mục đích sử dụng.";
		}
		if (transmission === 0 || !transmission) {
			this.setState({
				isTransmissionFilled: false,
			});
			return "Bạn chưa chọn loại truyền động.";
		}

		if (terms.length <= 0) {
			this.setState({
				isTermsFilled: false,
			});
			return "Bạn chưa chọn điều khoản bổ sung";
		}
		return "";
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	buildMakeCar = () => {
		const { parentModels, models } = this.state;

		let sameName = {};

		if (parentModels) {
			for (let i = 0; i < parentModels.length; i++) {
				if (parentModels[i].hasChild) {
					// parent có modelid
					parentModels[i]["models"] = [];

					models &&
						models.map((model, j) => {
							if (model.parentId === parentModels[i].id) {
								parentModels[i]["models"].push(model);
							}
						});
				}

				parentModels.map((parent, k) => {
					if (parent.hasChild && parent.models && parent.models.length === 1 && parent.name === parent.models[0].name) {
						sameName = {
							...sameName,
							[k]: true,
						};
					}
				});
			}
		}

		return { parentModels, sameName };
	};

	render() {
		const {
			step,
			makes,
			addtionalTerms,
			registry,
			makeId,
			transmission,
			showModel,
			showYear,
			modelId,
			models,
			years,
			regDay,
			terms,
			regType,
			year,
			showInsPrice,
			carName,
			pkgPrice,
			ins,
			type,
			isOpenRegisterBox,
			infoCar,
			carOrigins,
			carOrigin,
			title,
			nameBox,
			isOpenTTBox,
			showTNDS,
			isOpenTNDSBox,
			vehicleType,
			shown,
			pkgTNDS,
			shownTNDS,
			openChild,
			activeModel,
		} = this.state;
		const { errIns, discountsIns, pricePJICO, priceMIC } = this.props.ins;

		const parentModelsObj = this.buildMakeCar();

		const { parentModels, sameName } = parentModelsObj;

		if (addtionalTerms) {
			for (var i = 0; i < addtionalTerms.length; ++i) {
				var checked = false;
				if (terms) {
					for (var j = 0; j < terms.length; ++j) {
						if (addtionalTerms[i].id === terms[j]) {
							checked = true;
							break;
						}
					}
				}

				addtionalTerms[i].checked = checked;
			}
		}

		let termsArray = [];
		let regis;
		let commonDiscount;

		if (errIns >= commonErr.SUCCESS) {
			termsArray = priceMIC && priceMIC[0].termsPrice;
			regis = priceMIC && priceMIC[0].regType;
			commonDiscount = priceMIC && priceMIC[0].discounts;
		}

		return (
			<div className="mioto-layout">
				<Header />
				<section className="body">
					<div className="insurance-page">
						<div className="step-container space xl">
							<div className="m-container">
								<div className="step-by-step">
									<div className={`step-by-step__item ${step === 1 ? "active" : ""}`}>
										<h5 className="number-step">1</h5>
										<h6 className="title-step">Tìm sản phẩm bảo hiểm</h6>
									</div>
									<div className={`step-by-step__item ${step === 2 ? "active" : ""}`}>
										<h5 className="number-step">2</h5>
										<h6 className="title-step">Thông tin sản phẩm</h6>
									</div>
								</div>
							</div>
						</div>
						{step === 1 && (
							<>
								<div className="m-container space sec">
									<div className="insurance-container">
										<h4>Bảo Hiểm Vật Chất Xe Ô Tô</h4>
										<div className="d-flex ins-mb2">
											<div className="title">Thông Tin Xe* &gt;&nbsp;</div>
											{carName && <div className="title text-primary">{carName}</div>}
										</div>
										<div className="car-info">
											<div className="car-info-line option-radio">
												<div className="car-info--title">Hộp số</div>
												<div className="car-info--option">
													<div className="custom-radio">
														<input
															type="radio"
															id="transmission_mt"
															name="transmission_ins"
															onChange={() => this.onTransmissionChange(Transmission.MANUAL)}
														/>
														<label htmlFor="transmission_mt">Số sàn (MT)</label>
													</div>
													<div className="custom-radio">
														<input
															defaultChecked
															type="radio"
															id="transmission_at"
															name="transmission_ins"
															onChange={() => this.onTransmissionChange(Transmission.AUTO)}
														/>
														<label htmlFor="transmission_at">Số tự động (AT)</label>
													</div>
												</div>
											</div>
											<div className="car-info-line">
												<div className="car-info--title">
													Hãng Xe
													{makeId === 0 && <span> *</span>}
												</div>
												<div className="car-info--option">
													{makes &&
														makes.map((make) => (
															<div
																key={make.vehicleMakeId}
																className={`option-item${makeId === make.vehicleMakeId ? " active" : ""}`}
																onClick={() => this.onMakeChange(make.vehicleMakeId)}>
																<div className="option-item--box">
																	<img loading="lazy" src={make.logo} />
																	<p>{make.name}</p>
																</div>
															</div>
														))}
												</div>
											</div>
											<div className="car-info-line">
												<div className="car-info--title">
													Mẫu Xe
													{modelId === null && <span> *</span>}
												</div>
												{showModel ? (
													<div className="car-info--option">
														{parentModels &&
															parentModels.map((parentModel, i) => {
																if (parentModel.hasChild && !sameName[i]) {
																	return (
																		<div
																			key={i}
																			className={`option-item-wrap ${activeModel[i] ? "active" : ""}`}
																			onClick={() => this.showChildModel(i)}>
																			<div className="option-item">
																				<div className="option-item--box">
																					<p>{parentModel.name}</p>
																					{openChild[i] ? <IcCircleMinius /> : <IcCirclePlus />}
																				</div>
																			</div>
																			{openChild[i] &&
																				models &&
																				models.map((model, i) => {
																					if (model.parentId === parentModel.id)
																						return (
																							<div
																								className={`option child ${modelId == model.id ? "active" : ""}`}
																								key={i}
																								onClick={() => this.onModelChange(model)}>
																								<p>{model.name}</p>
																							</div>
																						);
																				})}
																		</div>
																	);
																} else if (parentModel.hasChild && sameName[i]) {
																	return (
																		<div
																			className={`option-item ${modelId == parentModel.models[0].id ? "active" : ""}`}
																			key={i}
																			onClick={() => this.onModelChange(parentModel.models[0])}>
																			<div className="option-item--box">
																				<p>{parentModel.models[0].name}</p>
																			</div>
																		</div>
																	);
																} else if (!parentModel.hasChild) {
																	return (
																		<div
																			key={i}
																			className={`option-item ${modelId === parentModel.id ? "active" : ""}`}
																			onClick={() => this.onModelChange(parentModel)}>
																			<div className="option-item--box">
																				<p>{parentModel.name}</p>
																			</div>
																		</div>
																	);
																}
															})}
													</div>
												) : (
													<div className="car-info--option">
														<span className="fontSize-s">Bạn chưa chọn hãng xe</span>
													</div>
												)}
											</div>
											<div className="car-info-line option-raido">
												<div className="car-info--title">Năm sản xuất{year === 0 && <span> *</span>}</div>
												{showYear ? (
													<div className="car-info--option">
														<div className="wrap-select">
															<select onChange={this.onYearChangeMobile} defaultValue={""}>
																{year == 0 && (
																	<option value="" disabled hidden>
																		Chọn năm
																	</option>
																)}
																{years.map((year, id) => (
																	<option key={id} value={year}>
																		{year}
																	</option>
																))}
															</select>
														</div>
													</div>
												) : (
													<div className="car-info--option">
														<span className="fontSize-s">Bạn chưa chọn mẫu xe</span>
													</div>
												)}
											</div>
										</div>
										<p
											className="need-advice car-info-line"
											onClick={() => this.showRegisterBox(TypeRegBox.MODEL_NOT_FOUND)}>
											Không tìm thấy xe của bạn?
										</p>
										<div className="car-info-line option-raido">
											<div className="car-info--title" onClick={() => this.showTTBox("CarOrigin", "Xuất xứ")}>
												Xuất Xứ*
											</div>
											<div className="car-info--option">
												{carOrigins &&
													carOrigins.map((opt) => (
														<div className="custom-radio" key={opt.id}>
															<input
																defaultChecked={opt.id === 1}
																type="radio"
																name="origin_ins"
																id={`origin_ins_${opt.id}`}
																value={opt.id}
																onChange={(e) => this.onCarOriginChange(e)}
															/>
															<label htmlFor={`origin_ins_${opt.id}`}>{opt.name}</label>
														</div>
													))}
											</div>
										</div>
										{carOrigin === CarOrigins.DOSMETIC ? (
											<div className="car-info-line option-raido">
												<div
													className="car-info--title"
													onClick={() => this.showTTBox("RegDay", "Ngày đăng ký lần đầu")}>
													Ngày Đăng Ký Lần Đầu {regDay === "" && <span> *</span>}
												</div>
												<div className="car-info--option">
													<div className="custom-input">
														<div className="wrap-input datepicker">
															<DatePicker
																selected={regDay}
																dateFormat="dd/MM/yyyy"
																placeholderText="DD/MM/YYYY"
																onChange={this.onRegDayChange}
																maxDate={new Date()}
																showMonthDropdown
																showYearDropdown
																dropdownMode="select"
															/>
														</div>
													</div>
												</div>
											</div>
										) : (
											<div className="car-info-line option-raido">
												<div className="car-info--title" onClick={() => this.showTTBox("RegYear", "Năm sản xuất")}>
													Năm Sản Xuất {regDay === "" && <span>*</span>}
												</div>
												<div className="car-info--option">
													<div className="custom-input">
														<div className="wrap-input datepicker">
															<DatePicker
																selected={regDay}
																dateFormat="yyyy"
																showYearPicker={true}
																placeholderText="YYYY"
																onChange={this.onRegDayChange}
																minDate={new Date("January 1, 1999")}
																maxDate={new Date()}
																yearItemNumber={6}
															/>
														</div>
													</div>
												</div>
											</div>
										)}
										<div className="car-info-line option-raido">
											<div className="car-info--title">
												Mục Đích Sử Dụng<span> *</span>
											</div>
											<div className="car-info--option">
												{registry &&
													registry.map((opt) => (
														<div className="custom-radio" key={opt.id}>
															<input
																type="radio"
																name="purpose_ins"
																id={`purpose_ins_${opt.id}`}
																value={opt.id}
																onChange={(e) => this.onRegistryChange(e)}
															/>
															<label htmlFor={`purpose_ins_${opt.id}`}>{opt.name}</label>
														</div>
													))}
											</div>
										</div>
										<div className="car-info-line">
											<div className="car-info--title">Điều Khoản Bổ Sung</div>
											<div className="car-info--option">
												{addtionalTerms &&
													addtionalTerms.map((term) => (
														<div className="custom-checkbox-selected" key={term.id}>
															<input
																type="checkbox"
																id={term.id}
																name="filter_purpose"
																onChange={(e) => this.onTermsCheckBoxChange(e, false)}
																value={term.id}
																checked={!!term.checked}
															/>
															<label htmlFor={term.id}>{term.name}</label>
															<div className="tooltip">
																<div className="wrap-svg">
																	<Tooltip />
																</div>
																<div className="tooltip-text">{term.desc}</div>
															</div>
														</div>
													))}
											</div>
										</div>
										<div className="d-flex-center" ref={this.myRef}>
											<a className="btn btn-primary" onClick={this.getPrice}>
												Báo phí sản phẩm bảo hiểm
											</a>
										</div>
									</div>
								</div>
								{showInsPrice && (
									<div className="m-container space sec">
										<div className="insurance-container">
											<h4>Chọn Gói Bảo Hiểm</h4>
											<div className="d-flex-align-center-wrap ins-mb">
												<div className="title">{carName}</div>
												<div className="car-tag">
													<p>{RegistryType[regis]}</p>
												</div>
											</div>
											<div className="ins-price-container">
												<div className="ins-price-table">
													<div className="price-table-title">
														<div className="title-unit">(Đơn vị tính: VNĐ)</div>
														<div className="title-content">
															<div className="title-header">
																<h6>Số Tiền Bảo Hiểm</h6>
															</div>
															<div className="title-content--line" />
															<div>
																<div className="ins-mb">
																	<h6>Quyền Lợi Bảo Hiểm</h6>
																</div>
																<p>
																	<strong>A. Bảo hiểm thân vỏ</strong>
																</p>
																{termsArray && termsArray[0].id === "ĐK001" ? (
																	<div className="custom-checkbox-selected">
																		<input
																			type="checkbox"
																			id={`terms_${termsArray[0].id}`}
																			name="term"
																			disabled
																			defaultChecked
																		/>
																		<label htmlFor={`terms_${termsArray[0].id}`}>
																			<strong>{termsArray[0].id} </strong> - {termsArray[0].name}
																		</label>
																	</div>
																) : null}
																<p className="space-nocheckbox">Phí niêm yết</p>
																<p className="space-nocheckbox">Chương trình giảm phí</p>
																<div className="title-content--space" />
																<p>
																	<strong>B. Điều khoản bổ sung</strong>
																</p>
																{addtionalTerms &&
																	addtionalTerms.map((term) => (
																		<div className="custom-checkbox-selected" key={term.id}>
																			<input
																				id={`term-${term.id}`}
																				type="checkbox"
																				value={term.id}
																				checked={!!term.checked}
																				onChange={(e) => this.onTermsCheckBoxChange(e, true)}
																			/>
																			<label htmlFor={`term-${term.id}`} style={{ whiteSpace: "nowrap" }}>
																				<strong>{term.id}</strong> - {term.name}
																			</label>
																		</div>
																	))}
															</div>
															<div className="title-content--line" />
															<div>
																<p>
																	<strong>TẠM TÍNH</strong>
																</p>
																<p className="space-left">10% VAT</p>
																{commonDiscount &&
																	commonDiscount.map((discount, i) => (
																		<p key={i} className="space-left">
																			{discount.name}
																		</p>
																	))}
															</div>
															<div className="title-content--line" />
															<div>
																<h6>THÀNH TIỀN</h6>
																<p>(Đã bao gồm 10% VAT)</p>
															</div>
														</div>
													</div>
													<div className="price-table-detail">
														<div className="ins-partner-title">
															<img loading="lazy" className="ic-mr" src={pjico} />
															<h5>Bảo Hiểm PJICO</h5>
														</div>
														<div className="price-table-container" style={{ alignItems: "flex-start" }}>
															{pricePJICO &&
																pricePJICO.map((price) => (
																	<div key={price.id} className="price-table-wrap">
																		<div>
																			<div className="price-table-line" />
																			<div className="ins-partner-type">
																				<div className="partner-type-name">{price.name}</div>
																				{price.isRecommended ? (
																					<div className="recommend-tag">
																						<span>Đề xuất</span>
																					</div>
																				) : null}
																			</div>
																			<div className="ins-partner-price">
																				<NumberFormat
																					value={price.carPrice}
																					displayType={"text"}
																					thousandSeparator={" "}
																					decimalSeparator={","}
																				/>
																			</div>
																			<div className="ins-partner-note">{price.desc}</div>
																			<div className="price-table-line" />
																			<div>
																				<h6 />
																				<p />
																				{price.termsPrice[0].id === "ĐK001" ? (
																					<p>
																						<NumberFormat
																							value={price.termsPrice[0].price}
																							displayType={"text"}
																							thousandSeparator={" "}
																							decimalSeparator={","}
																						/>
																					</p>
																				) : null}
																				<p>
																					<NumberFormat
																						value={price.priceNiemYet}
																						displayType={"text"}
																						thousandSeparator={" "}
																						decimalSeparator={","}
																					/>
																				</p>
																				{price.priceNiemYet > price.termsPrice[0].price ? (
																					<p>
																						-{" "}
																						<NumberFormat
																							value={price.priceNiemYet - price.termsPrice[0].price}
																							displayType={"text"}
																							thousandSeparator={" "}
																							decimalSeparator={","}
																						/>
																					</p>
																				) : (
																					<p>-</p>
																				)}
																			</div>
																			<div className="price-table-line" />
																			<div>
																				<p />
																				{price.termsPrice.map((term) => {
																					if (term.id === "ĐK001") return;
																					return (
																						<p key={term.id}>
																							{term.price > 0 ? (
																								<NumberFormat
																									value={term.price}
																									displayType={"text"}
																									thousandSeparator={" "}
																									decimalSeparator={","}
																								/>
																							) : term.price === 0 ? (
																								"Tặng kèm"
																							) : (
																								"Không hỗ trợ"
																							)}{" "}
																						</p>
																					);
																				})}
																			</div>
																			<div className="price-table-line" />
																			<div>
																				<p>
																					<NumberFormat
																						value={price.priceTotal}
																						displayType={"text"}
																						thousandSeparator={" "}
																						decimalSeparator={","}
																					/>
																				</p>
																				<p>
																					<NumberFormat
																						value={price.priceTotalVAT}
																						displayType={"text"}
																						thousandSeparator={" "}
																						decimalSeparator={","}
																					/>
																				</p>
																				{price.discounts.map((discount, i) => (
																					<>
																						{discount.price > 0 ? (
																							<p>
																								-{" "}
																								<NumberFormat
																									value={discount.price}
																									displayType={"text"}
																									thousandSeparator={" "}
																									decimalSeparator={","}
																								/>{" "}
																								({discount.discountPercent}%)
																							</p>
																						) : (
																							<p>-</p>
																						)}
																					</>
																				))}
																			</div>
																			<div className="price-table-line" />
																			<div className="price-table-total">
																				<NumberFormat
																					value={price.priceFinal}
																					displayType={"text"}
																					thousandSeparator={" "}
																					decimalSeparator={","}
																				/>
																			</div>
																		</div>
																		<div className="price-table-btn">
																			<button
																				className="btn btn-primary"
																				onClick={() => this.onSubmitPackagePrice(price.id)}>
																				CHỌN MUA
																			</button>
																		</div>
																	</div>
																))}
														</div>
													</div>
													<div className="price-table-detail">
														<div className="ins-partner-title">
															<img loading="lazy" className="ic-mr" src={mic} />
															<h5>Bảo Hiểm MIC</h5>
														</div>
														<div className="price-table-container" style={{ alignItems: "flex-start" }}>
															{priceMIC &&
																priceMIC.map((price) => (
																	<div key={price.id} className="price-table-wrap">
																		<div>
																			<div className="price-table-line" />
																			<div className="ins-partner-type">
																				<div className="partner-type-name">{price.name}</div>
																				{price.isRecommended ? (
																					<div className="recommend-tag">
																						<span>Đề xuất</span>
																					</div>
																				) : null}
																			</div>
																			<div className="ins-partner-price">
																				<NumberFormat
																					value={price.carPrice}
																					displayType={"text"}
																					thousandSeparator={" "}
																					decimalSeparator={","}
																				/>
																			</div>
																			<div className="ins-partner-note">{price.desc}</div>
																			<div className="price-table-line" />
																			<div>
																				<h6 />
																				<p />
																				{price.termsPrice[0].id === "ĐK001" ? (
																					<p>
																						<NumberFormat
																							value={price.termsPrice[0].price}
																							displayType={"text"}
																							thousandSeparator={" "}
																							decimalSeparator={","}
																						/>
																					</p>
																				) : null}
																				<p>
																					<NumberFormat
																						value={price.priceNiemYet}
																						displayType={"text"}
																						thousandSeparator={" "}
																						decimalSeparator={","}
																					/>
																				</p>
																				{price.priceNiemYet > price.termsPrice[0].price ? (
																					<p>
																						-{" "}
																						<NumberFormat
																							value={price.priceNiemYet - price.termsPrice[0].price}
																							displayType={"text"}
																							thousandSeparator={" "}
																							decimalSeparator={","}
																						/>
																					</p>
																				) : (
																					<p>-</p>
																				)}
																			</div>
																			<div className="price-table-line" />
																			<div>
																				<p />
																				{price.termsPrice.map((term) => {
																					if (term.id === "ĐK001") return;
																					return (
																						<p key={term.id}>
																							{term.price > 0 ? (
																								<NumberFormat
																									value={term.price}
																									displayType={"text"}
																									thousandSeparator={" "}
																									decimalSeparator={","}
																								/>
																							) : term.price === 0 ? (
																								"Tặng kèm"
																							) : (
																								"Không hỗ trợ"
																							)}{" "}
																						</p>
																					);
																				})}
																			</div>
																			<div className="price-table-line" />
																			<div>
																				<p>
																					<NumberFormat
																						value={price.priceTotal}
																						displayType={"text"}
																						thousandSeparator={" "}
																						decimalSeparator={","}
																					/>
																				</p>
																				<p>
																					<NumberFormat
																						value={price.priceTotalVAT}
																						displayType={"text"}
																						thousandSeparator={" "}
																						decimalSeparator={","}
																					/>
																				</p>
																				{price.discounts.map((discount, i) => (
																					<>
																						{discount.price > 0 ? (
																							<p>
																								-{" "}
																								<NumberFormat
																									value={discount.price}
																									displayType={"text"}
																									thousandSeparator={" "}
																									decimalSeparator={","}
																								/>{" "}
																								({discount.discountPercent}%)
																							</p>
																						) : (
																							<p>-</p>
																						)}
																					</>
																				))}
																			</div>
																			<div className="price-table-line" />
																			<div className="price-table-total">
																				<NumberFormat
																					value={price.priceFinal}
																					displayType={"text"}
																					thousandSeparator={" "}
																					decimalSeparator={","}
																				/>
																			</div>
																		</div>
																		<div className="price-table-btn">
																			<button
																				className="btn btn-primary"
																				onClick={() => this.onSubmitPackagePrice(price.id)}>
																				CHỌN MUA
																			</button>
																		</div>
																	</div>
																))}
														</div>
													</div>
												</div>
											</div>
											<p className="need-advice" onClick={() => this.showRegisterBox(TypeRegBox.INS_NOT_FOUND)}>
												Tôi cần tư vấn thêm
											</p>
											{discountsIns && discountsIns.length > 0 && (
												<div className="ins-promo-container">
													<div className="ins-promo--title">Chương trình khuyến mãi:</div>
													{discountsIns.map((discount, i) => {
														{
															/* 
															let discountMin =
															discount.discountMap && discount.discountMap.discounts
																	? discount.discountMap.discounts[2]
																	: "";
															let discountMax =
																discount.discountMap && discount.discountMap.discounts
																	? discount.discountMap.discounts[1]
																	: "";
														*/
														}
														return (
															<React.Fragment key={i}>
																<p>
																	{i + 1}. {discount.name}
																</p>
																{/* {(discountMin !== "" || discountMax !== "") ? <p>Giảm <strong>{discountMin.discountPercent === discountMax.discountPercent ? `${discountMin.discountPercent * 100}%` : `${discountMin.discountPercent * 100}% - ${discountMax.discountPercent * 100}`}</strong> {(discountMin.discountMax > 0 || discountMax.discountMax > 0) ?(discountMin.discountMax === discountMax.discountMax) ? `(tối đa ${discountMin.discountMax}K)` : `(tối đa ${discountMin.discountMax - discountMax.discountMax}K)` : null }</p> : ""} */}
															</React.Fragment>
														);
													})}
												</div>
											)}
											<p>
												Liên hệ Mioto tại{" "}
												<strong>
													{" "}
													<a href="tel:19009217" className="text-primary">
														1900 9217{" "}
													</a>
												</strong>
												(7AM-10PM) hoặc inbox{" "}
												<strong>
													<a className="text-primary" target="_blank" href="https://www.messenger.com/t/mioto.vn">
														Mioto Fanpage
													</a>{" "}
												</strong>
												nếu bạn cần hỗ trợ !
											</p>
										</div>
									</div>
								)}
							</>
						)}
						{step === 2 && (
							<>
								<div className="m-container space sec">
									<div className="insurance-container">
										<div className="btn-return pointer" onClick={() => this.onStep(1)}>
											<div className="wrap-svg">
												<IcBack />
											</div>
										</div>
										<h4 className="ins-notmb">Bản Chào Phí Bảo Hiểm Kết Hợp Xe Ô Tô</h4>
										<p className="textAlign-center">(Đơn vị tính: VNĐ)</p>
										<div className="price-list-container">
											<div className="price-list--green">
												<div className="price-list--wrap">
													<p className="fontWeight-6">Loại Xe</p>
													<p>{carName}</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Năm Sản Xuất</p>
													<p>{year}</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Mục Đích Sử Dụng</p>
													<p>{RegistryType[pkgPrice.regType]}</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Thời Hạn Bảo Hiểm</p>
													<p>12 tháng</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Nhà Bảo Hiểm</p>
													<div className="price-list-ins-partner">
														{ins === Insurance.MIC ? <img loading="lazy" src={mic} /> : <img loading="lazy" src={pjico} />}
														<p>{ins === Insurance.MIC ? "Bảo hiểm quân đội MIC" : "Bảo hiểm PJICO"}</p>
													</div>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Số Tiền Bảo Hiểm</p>
													<p>
														<NumberFormat
															value={pkgPrice.carPrice}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
											</div>
											<div>
												<div className="price-list--wrap">
													<p className="title">Quyền Lợi Bảo Hiểm</p>
													<p className="title">Phí BH</p>
												</div>
												<div className="price-list--line" />
												{pkgPrice.termsPrice.map((term) => {
													if (term.selected && term.price >= 0) {
														return (
															<div key={term.id} className="price-list--wrap">
																<p>
																	<strong>{term.id} </strong>- {term.name}
																</p>
																{term.price > 0 ? (
																	<p>
																		<NumberFormat
																			value={term.price}
																			displayType={"text"}
																			thousandSeparator={" "}
																			decimalSeparator={","}
																		/>
																	</p>
																) : term.price === 0 ? (
																	<p>Tặng kèm</p>
																) : (
																	<p>Không hỗ trợ</p>
																)}
															</div>
														);
													}
												})}
												<div className="price-list--line" />
												<div className="price-list--wrap">
													<p className="fontWeight-6">Tổng Phí Bảo Hiểm Vật Chất Xe Ô Tô</p>
													<p>
														<NumberFormat
															value={pkgPrice.priceTotal}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
												<div className="price-list--wrap">
													<p className="fontWeight-6">Tổng Phí (Gồm 10% VAT)</p>
													<p>
														<NumberFormat
															value={pkgPrice.priceTotalVAT}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
												{pkgPrice.discounts &&
													pkgPrice.discounts.map((discount, i) => {
														if (discount.price > 0) {
															return (
																<div key={i} className="price-list--wrap">
																	<p className="fontWeight-6">{discount.name}</p>
																	{discount.price > 0 ? (
																		<p>
																			-{" "}
																			<NumberFormat
																				value={discount.price}
																				displayType={"text"}
																				thousandSeparator={" "}
																				decimalSeparator={","}
																			/>
																		</p>
																	) : discount.price === 0 ? (
																		<p>Tặng kèm</p>
																	) : (
																		<p>- </p>
																	)}
																</div>
															);
														}
													})}
												<div className="price-list--line" />
												<div className="price-list--wrap">
													<p className="title">TỔNG PHÍ ĐÃ GIẢM (GỒM 10% VAT)</p>
													<p className="title">
														<NumberFormat
															value={pkgPrice.priceFinal}
															displayType={"text"}
															thousandSeparator={" "}
															decimalSeparator={","}
														/>
													</p>
												</div>
											</div>
										</div>
										<div className="want-buy-tnds">
											<div className="custom-checkbox-selected">
												<input type="checkbox" value={showTNDS} onChange={this.toggleTNDSBox} id="buy_tnds" />
												<label htmlFor="buy_tnds">Tôi muốn mua kèm bảo hiểm TNDS</label>
											</div>
										</div>
										{showTNDS && (
											<div className="price-list-container">
												<div className="price-list--tnds">
													{this.props.ins.err == commonErr.LOADING ? (
														<LoadingInline />
													) : this.props.ins.err >= commonErr.SUCCESS ? (
														<>
															<div className="df-align-center">
																<img loading="lazy" src={pti} />
																<div className="main-content">
																	<p>Phí bảo hiểm TNDS bắt buộc</p>
																	<div className="ins-discount">
																		<NumberFormat
																			value={this.props.ins.price.priceFinal}
																			displayType={"text"}
																			thousandSeparator={" "}
																			decimalSeparator={","}
																		/>
																	</div>
																</div>
															</div>
															<button onClick={() => this.showTNDSBox()} className="btn btn-primary">
																Xem chi tiết
															</button>
														</>
													) : null}
												</div>
											</div>
										)}
									</div>
									<div className="ins-sumary-container">
										<div className="price-list--wrap">
											<p className="fontWeight-6">Tổng phí BH vật chất xe ô tô</p>
											<p>
												<NumberFormat
													value={pkgPrice.priceFinal}
													displayType={"text"}
													thousandSeparator={" "}
													decimalSeparator={","}
												/>
											</p>
										</div>
										{showTNDS ? (
											<>
												{this.props.ins.err == commonErr.LOADING ? (
													<LoadingInline />
												) : this.props.ins.err >= commonErr.SUCCESS ? (
													<div className="price-list--wrap">
														<p className="fontWeight-6">Tổng phí BH TNDS bắt buộc</p>
														<p>
															<NumberFormat
																value={this.props.ins.price.priceFinal}
																displayType={"text"}
																thousandSeparator={" "}
																decimalSeparator={","}
															/>
														</p>
													</div>
												) : null}
											</>
										) : null}
										{showTNDS && (
											<>
												{this.props.ins.err == commonErr.LOADING ? (
													<LoadingInline />
												) : this.props.ins.err >= commonErr.SUCCESS ? (
													<div className="price-list--wrap">
														<h6 className="title">Tổng phí</h6>
														<h6 className="title">
															<NumberFormat
																value={pkgPrice.priceFinal + this.props.ins.price.priceFinal}
																displayType={"text"}
																thousandSeparator={" "}
																decimalSeparator={","}
															/>
														</h6>
													</div>
												) : (
													<div className="price-list--wrap">
														<h6 className="title">Tổng phí</h6>
														<h6 className="title">{pkgPrice.priceFinal}</h6>
													</div>
												)}
											</>
										)}
										<div className="price-list--wrap">
											<button
												className="btn btn-blue btn--m"
												onClick={() => this.showRegisterBox(TypeRegBox.INS_NOT_FOUND)}>
												Tôi cần tư vấn thêm
											</button>
											<button
												className="btn btn-primary btn--m"
												onClick={() => this.showRegisterBox(TypeRegBox.BOOKING)}>
												Đặt mua sản phẩm bảo hiểm
											</button>
										</div>
									</div>
								</div>
								<div className="m-container space sec">
									<div className="insurance-container">
										<h4>Giải Thích Các Thuật Ngữ Và Điều Khoản</h4>
										<div className="ins-explain">
											<div className="ins-explain-wrap active">
												<div className="df-align-center">
													<div className="wrap-svg ic-mr">
														<IcInsuranceCar />
													</div>
													<h6>Bảo Hiểm Vật Chất Xe Ô Tô</h6>
												</div>
												<div className="wrap-svg">
													<IcMinusGreenCircle />
												</div>
											</div>
											{pkgPrice.termsPrice[0].selected && (
												<div className={`ins-explain-item`}>
													<div
														className={`ins-explain-wrap ${shown[0] ? "active" : ""}`}
														onClick={() => this.toggleExplain(0)}>
														<div className="ins-explain--title">
															ĐK 001 - Bảo hiểm vật chất xe (
															{pkgPrice.regType === 3
																? "PJICO khấu trừ 1.000.000 vnd/vụ, MIC khấu trừ 500.000 vnd/vụ"
																: "khấu trừ 500.000 vnd/vụ"}
															)
														</div>
														{shown[0] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
													</div>
													{shown[0] && (
														<p>
															Bảo hiểm vật chất xe do đâm va, hỏa hoạn, cháy nổ và các rủi ro bất khả kháng do thiên
															tai, mất toàn bộ xe do trộm cướp, hành vi phá hoại của bên thứ ba…. Hỗ trợ chi phí cứu hộ
															và vận chuyển xe bị thiệt hại đến nơi sửa chữa gần nhất (không quá 10% số tiền bảo hiểm).
														</p>
													)}
												</div>
											)}
											{pkgPrice.termsPrice[1].selected && (
												<div className={`ins-explain-item`}>
													<div
														className={`ins-explain-wrap ${shown[1] ? "active" : ""}`}
														onClick={() => this.toggleExplain(1)}>
														<div className="ins-explain--title">ĐK 002 - Bảo hiểm mất cắp bộ phận</div>
														{shown[2] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
													</div>
													{shown[1] && (
														<p>
															Xe được bảo hiểm trong trường hợp mất cắp bộ phận. Giới hạn số lần mất trộm/cắp: 01 lần
															cho mỗi bộ phận, không quá 2 lần/năm (Mức khấu trừ: 20% tổn thất và tối thiểu 2.000.000
															đồng/vụ, tùy số nào lớn hơn).
														</p>
													)}
												</div>
											)}
											{pkgPrice.termsPrice[2].selected && (
												<div className={`ins-explain-item`}>
													<div
														className={`ins-explain-wrap ${shown[2] ? "active" : ""}`}
														onClick={() => this.toggleExplain(2)}>
														<div className="ins-explain--title">ĐK 004 - Bảo hiểm mới thay cũ</div>
														{shown[2] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
													</div>
													{shown[2] && <p>Xe được thay mới bộ phận và không tính khấu hao.</p>}
												</div>
											)}
											{pkgPrice.termsPrice[3].selected && (
												<div className={`ins-explain-item`}>
													<div
														className={`ins-explain-wrap ${shown[3] ? "active" : ""}`}
														onClick={() => this.toggleExplain(3)}>
														<div className="ins-explain--title">ĐK 005 - Bảo hiểm lựa chọn cơ sở sửa chữa </div>
														{shown[3] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
													</div>
													{shown[3] && (
														<p>
															Chủ xe được đăng kí lựa chọn sửa chữa tại các garage nằm ngoài danh sách garage liên kết
															của nhà bảo hiểm.
														</p>
													)}
												</div>
											)}
											{pkgPrice.termsPrice[4].selected && (
												<div className={`ins-explain-item`}>
													<div
														className={`ins-explain-wrap ${shown[4] ? "active" : ""}`}
														onClick={() => this.toggleExplain(4)}>
														<div className="ins-explain--title">ĐK 006 - Bảo hiểm thủy kích</div>
														{shown[4] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
													</div>
													{shown[4] && (
														<p>
															Xe được bảo hiểm động cơ trong trường hợp ngập nước (Mức khấu trừ tối thiểu 20% tổn thất
															và tối thiểu 3.000.000 đồng/vụ, tùy số nào lớn hơn).
														</p>
													)}
												</div>
											)}
											<div className={`ins-explain-item`}>
												<div
													className={`ins-explain-wrap ${shown[5] ? "active" : ""}`}
													onClick={() => this.toggleExplain(5)}>
													<div className="ins-explain--title">Số tiền bảo hiểm</div>
													{shown[5] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
												</div>
												{shown[5] && (
													<p>
														Là số tiền mà chủ xe yêu cầu nhà bảo hiểm bảo hiểm cho xe của mình và được ghi trên Giấy
														chứng nhận bảo hiểm.
													</p>
												)}
											</div>
											<div className={`ins-explain-item`}>
												<div
													className={`ins-explain-wrap ${shown[6] ? "active" : ""}`}
													onClick={() => this.toggleExplain(6)}>
													<div className="ins-explain--title">Mức khấu trừ</div>
													{shown[6] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
												</div>
												{shown[6] && (
													<p>
														Là số tiền chủ xe tự chịu trong mỗi sự cố. Trường hợp số tiền tổn thất nhỏ hơn Mức khấu trừ,
														nhà bảo hiểm không phải bồi thường cho tổn thất đó.
													</p>
												)}
											</div>
										</div>
										{showTNDS && (
											<div className="ins-explain">
												<div className="ins-explain-wrap active">
													<div className="ins-explain-wrap">
														<div className="wrap-svg ic-mr">
															<IcInsuranceCar />
														</div>
														<h6>Bảo hiểm TNDS bắt buộc</h6>
													</div>
													<div className="wrap-svg">
														<IcMinusGreenCircle />
													</div>
												</div>
												<div className={`ins-explain-item`}>
													<div
														className={`ins-explain-wrap ${shownTNDS[0] ? "active" : ""}`}
														onClick={() => this.toggleExplainTNDS(0)}>
														<div className="ins-explain--title">Bảo hiểm TNDS bắt buộc</div>
														{shownTNDS[0] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
													</div>
													{shownTNDS[0] && (
														<>
															<p>
																Nhà bảo hiểm thay mặt chủ xe bồi thường các tổn thất về người và tài sản cho bên thứ ba
																(bên bị thiệt hai do xe của chủ xe gây ra).
															</p>
															<p>Về người: tối đa 150 triệu đồng/người /vụ.</p>
															<p>Về tài sản: theo tổn thất thực tế, tối đa 100 triệu đồng/vụ.</p>
														</>
													)}
												</div>
												<div className={`ins-explain-item`}>
													<div
														className={`ins-explain-wrap ${shownTNDS[1] ? "active" : ""}`}
														onClick={() => this.toggleExplainTNDS(1)}>
														<div className="ins-explain--title">Bảo hiểm người ngồi trên xe</div>
														{shownTNDS[1] ? <IcMinusGreenCircle /> : <IcPlusCircle />}
													</div>
													{shownTNDS[1] && (
														<>
															<p>
																Nhà bảo hiểm bồi thường thiệt hại về thân thể đối với lái xe và người được chở trên xe
																với điều kiện những người này bị tai nạn khi đang ở trên xe, lên xuống xe trong quá
																trình xe ô tô đang tham gia giao thông.
															</p>
															<p>Mức trách nhiệm 10 triệu đồng/người/vụ.</p>
														</>
													)}
												</div>
											</div>
										)}
									</div>
								</div>
								<div className="m-container space sec">
									<div className="insurance-container">
										<h4>Phương Thức Thanh Toán</h4>
										<div className="ins-payment-method">
											<h6>Chuyển khoản qua tài khoản ngân hàng của Mioto:</h6>
											<p>Ngân hàng Vietcombank (Chi nhánh Tân Định)</p>
											<p>Tên tài khoản: CT CP MIOTO ASIA</p>
											<p>Số tài khoản: 102-989-1989</p>
											<p>Nội dung: Thanh toán tiền mua bảo hiểm - Tên chủ xe - SĐT chủ xe</p>
										</div>
									</div>
								</div>
								<div className="insurance-home">
									<InsuranceProcess />
								</div>
							</>
						)}
					</div>
					<TooltipBox isShow={isOpenTTBox} hide={this.hideTTBox} title={title} name={nameBox} />
					<RegisterBox
						isShow={isOpenRegisterBox}
						hide={this.hideRegisterBox}
						type={type}
						pkgPrice={pkgPrice}
						infoCar={infoCar}
						pkgTNDS={pkgTNDS}
					/>
					<TNDSBox
						isShow={isOpenTNDSBox}
						hide={this.hideTNDSBox}
						ins={this.props.ins}
						getTNDS={this.getTNDS}
						vehicleType={vehicleType}
						regType={regType}
						getTNDSParams={this.getTNDSParams}
					/>
					<MessageBox
						show={this.state.err <= commonErr.SUCCESS}
						hideModal={this.hideMessageBox}
						message={this.state.errMsg}
						error={this.state.err}
					/>
				</section>
				<Footer />
			</div>
		);
	}
}

function mapState(state) {
	return {
		ins: state.ins,
	};
}

InsuranceRegister = connect(mapState)(InsuranceRegister);

export default InsuranceRegister;
